import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ICurrentUser, setUser } from '../../features/currentUser/currentUserSlice';

import { ChecksAndPasswordFormGroup } from './components/ChecksAndPasswordFormGroup';

import './ResetPassword.scss';

export const ResetPassword = () => {
  const prefix = 'reset-';

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleResetSuccess = (auth: Omit<ICurrentUser, 'roles'>) => {
    if (!auth.accessToken || !auth.refreshToken) {
      console.error('Reset password succeeded but tokens are missing from response', auth);
      return;
    }
    dispatch(
      setUser({ accessToken: auth.accessToken, refreshToken: auth.refreshToken, save: true })
    );

    history.push('/communities');
  };

  return (
    <div className="raqt-reset">
      <div className="raqt-reset__title">{t(prefix + 'title')}</div>
      <ChecksAndPasswordFormGroup onSubmit={handleResetSuccess} />
    </div>
  );
};
